module.exports = __webpack_public_path__ + "mainassets/img/chevron-down.f4c7ba13.svg";